import DatePickerInputVariant from './DatePickerInputVariant';
export default DatePickerInputVariant;
